const userHeaderInfo = 'USER_HEADER_INFO';
const storeDetail = 'STORE_DETAIL';
const creditBalance = 'CREDIT_BALANCE';

export const type = {
  userHeaderInfo,
  storeDetail,
  creditBalance,
};

export default (state = {}, action) => {
  switch (action.type) {
    case 'EDITOR':
    case 'USER_DETAIL':
    case userHeaderInfo:
    case storeDetail:
    case 'PRODUCT_PAGE_PATH':
      return {
        ...state,
        ...action.payload
      };
    case creditBalance:
      return {
        ...state,
        userHeaderInfo: {
          ...state.userHeaderInfo,
          ...action.payload
        },
      };
    case 'SET_LANGUAGE':
      return {
        ...state,
        langCode: action.payload
      };
    case 'SET_DEFAULT_LANGUAGE':
      return {
        ...state,
        defaultLangCode: action.payload
      };
    case 'SET_BACKEND_CONFIG':
      return {
        ...state,
        backendConfig: action.payload
      }
    case 'SET_TRANSLATION':
      return {
        ...state,
        translations: { ...state.translations, ...action.payload }
      };

    case 'SET_CURRENT_PAGE_NAME':
      return {
        ...state,
        currentPageName: action.payload
      }

    case 'SET_PAYPAL_PAY_LATER':
      return {
        ...state,
        paypalPayLater: action.payload
      }

    case 'SET_AB_FEATURE_CONFIG':
      return {
        ...state,
        abFeatureConfig: action.payload
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducer/index.js